export default __webpack_public_path__ + "logo04fc8659.png";